import React, { FC, useState } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStore,
  faShop,
  faUser,
  faTicket,
  faPercent,
  faLocationDot,
  faAward,
  faFolder,
  faBoxOpen,
  faWarehouse,
  faClipboardList,
  faStar,
  faTags,
  faCashRegister
} from "@fortawesome/free-solid-svg-icons";

const Dashboard: FC = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const permissions = usePermissions();

  const dashboardItems = [
    { name: "Checkout", route: "/checkout", icon: faCashRegister, roles: ['O', 'A', 'S'] },
    { name: "Stores", route: "/stores", icon: faStore, roles: ['O', 'A', 'S'] },
    { name: "Shops", route: "/shops", icon: faShop, roles: ['O', 'A', 'S'] },
    { name: "Brands", route: "/brands", icon: faAward, roles: ['O', 'A', 'S'] },
    { name: "Categories", route: "/category", icon: faFolder, roles: ['O', 'A', 'S'] },
    { name: "Products", route: "/products", icon: faBoxOpen, roles: ['O', 'A', 'S'] },
    { name: "Store Discount", route: "/store-discount", icon: faPercent, roles: ['O', 'A', 'S'] },
    { name: "Shop Discount", route: "/shop-discount", icon: faPercent, roles: ['O', 'A', 'S'] },
    { name: "Brand Discount", route: "/brand-discount", icon: faTags, roles: ['O', 'A', 'S'] },
    { name: "Category Discount", route: "/category-discount", icon: faPercent, roles: ['O', 'A', 'S'] },
    { name: "Product Discount", route: "/product-discount", icon: faTags, roles: ['O', 'A', 'S'] },
    { name: "Order", route: "/order", icon: faClipboardList, roles: ['O', 'A', 'S'] },
    { name: "Inventory", route: "/inventory", icon: faWarehouse, roles: ['O', 'A', 'S'] },
    { name: "Coupons", route: "/coupons", icon: faTicket, roles: ['O', 'A', 'S'] },
    { name: "Review", route: "/review", icon: faStar, roles: ['O', 'A', 'S'] },
    { name: "Users", route: "/users", icon: faUser, roles: ['O'] },
    { name: "Address", route: "/address", icon: faLocationDot, roles: ['O'] },
  ];

  const filteredItems = dashboardItems.filter(item => {
    // Check if user role is allowed for this item
    const hasPermission = item.roles.includes(permissions.userType);
    // Check if item matches search term
    const matchesSearch = item.name.toLowerCase().includes(search.toLowerCase());
    return hasPermission && matchesSearch;
  });

  return (
    <div className={style.wrapper}>
      <div className={style.header}>
        <h1 className={style.title}>Dashboard</h1>
        <input
          type="text"
          placeholder="Search modules..."
          className={style.search}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className={style.grid}>
        {filteredItems.map((item, index) => (
          <div
            key={index}
            className={style.card}
            onClick={() => {
              console.log('Navigating to:', item.route);
              navigate(item.route);
            }}
          >
            <div className={style.cardIcon}>
              <FontAwesomeIcon icon={item.icon} />
            </div>
            <h3>{item.name}</h3>
            <p>Manage {item.name.toLowerCase()}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;


